import { MealCategoryType } from 'models/meal-category.model';
import { MealType } from 'models/meal.model';
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { ENUM_ORDERS_TYPE } from 'utils/enum';
import { formatCurrency } from 'utils/functions';

type Props = MealCategoryType & {
  active: boolean;
  orderType: ENUM_ORDERS_TYPE;
  isBusy: boolean;
  isBrandOpen: boolean;
};

const MealCategory = (props: Props) => {
  const { id, name, meals, active, orderType, isBusy, isBrandOpen } = props;

  const isSoldOut = (meal: MealType) => meal.active && meal.available_no === '0';
  const disableLink = (meal: MealType) => !isBrandOpen || isBusy || isSoldOut(meal);

  return (
    <Fragment>
      {meals.length > 0 ? (
        <div
          key={id}
          data-key={id}
          className={`flex flex-col gap-3 meal_container meal_container${id} ${
            active ? 'active' : ''
          }`}>
          <p className={`category_header${id} mb-3 font-semibold`}>{name}</p>
          <div className='w-full grid grid-cols-1 sm:grid-cols-[repeat(auto-fill,_minmax(342px,_1fr))] gap-5'>
            {meals.map((meal) => (
              <Link
                key={meal.id}
                to={
                  disableLink(meal)
                    ? `?type=${orderType}#`
                    : `/orders/meals/${meal.id}?type=${orderType}`
                }
                className={disableLink(meal) ? 'cursor-not-allowed' : 'cursor-pointer'}>
                <div className='w-full flex flex-col-reverse sm:flex-row justify-between gap-4 pl-4 sm:pl-0 py-4 pr-4 rounded-lg border-[0.8px] border-[#ededee]'>
                  <div
                    className={`relative flex flex-col justify-between pl-4 border-l-[3px] ${
                      meal.orderCount ? 'border-red-5' : 'border-transparent'
                    }`}>
                    <div className='flex flex-col gap-1'>
                      <p className='font-medium'>
                        {meal.orderCount ? (
                          <span className='text-red-5 font-normal'>
                            {meal.orderCount}x&nbsp;&nbsp;&nbsp;
                          </span>
                        ) : null}
                        {meal.name}
                      </p>
                      <p className='text-sm text-[#6F7376] line-clamp-3'>{meal.description}</p>
                    </div>
                    <p className='text-gray-9'>{formatCurrency(meal.price)}</p>
                    {isSoldOut(meal) || !isBrandOpen ? (
                      <div className='absolute top-0 right-0 bottom-0 left-0 bg-white/40' />
                    ) : null}
                  </div>
                  <div className='shrink-0 relative w-full sm:w-[150px] h-[150px]'>
                    <div className='relative'>
                      <img
                        src={meal.image}
                        alt='meal'
                        className={`w-full h-full sm:h-[unset] aspect-[unset] sm:aspect-square object-cover rounded-md ${
                          !isBrandOpen || isBusy ? 'brightness-[30%]' : ''
                        }`}
                      />
                      {isBrandOpen && isSoldOut(meal) ? (
                        <span className='absolute top-0 right-0 bottom-0 left-0 flex items-center justify-center text-center bg-[#080808B2] rounded-md'>
                          <p className='max-w-[61px] text-xl text-white font-medium'>Sold out</p>
                        </span>
                      ) : isBusy ? (
                        <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
                          <p className='font-medium text-2xl text-white text-center'>Busy</p>
                        </div>
                      ) : !isBrandOpen ? (
                        <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
                          <p className='font-medium text-2xl text-white text-center'>Closed</p>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      ) : null}
    </Fragment>
  );
};

export default MealCategory;
